import { Button, ModalWindow, UIHeading2, UIText1 } from '@cian/ui-kit';
import { IconActionClose24 } from '@cian/ui-kit-design-tokens/icons';

import { type FC } from 'react';

import styles from './styles.css';

interface ICallbackFallbackModalProps {
  isOpen: boolean;
  isLoading: boolean;
  onClose(): void;
  onRetry(): void;
}

/**
 * Модалка отображается, если не удалось показать виджет колбэка.
 */
export const CallbackFallbackModal: FC<ICallbackFallbackModalProps> = ({ isLoading, isOpen, onClose, onRetry }) => {
  return (
    <ModalWindow
      content={
        <div className={styles['content']} data-testid="CallbackFallbackModalContent">
          <div className={styles['icon-wrapper']}>
            <IconActionClose24 color="icon-negative-default" />
          </div>
          <div className={styles['heading']}>
            <UIHeading2>Что-то пошло не так...</UIHeading2>
          </div>
          <UIText1>Попробуйте ещё раз</UIText1>
        </div>
      }
      fixed={false}
      footer={
        <div className={styles['footer']}>
          <Button fullWidth={false} loading={isLoading} size="XS" onClick={onRetry}>
            Попробовать ещё раз
          </Button>
        </div>
      }
      open={isOpen}
      width={648}
      onClose={onClose}
    />
  );
};
